export const EMAIL_OTP_REQUEST_MINUTES = 3;

export const LOGIN_TYPE = {
    learner: 'Learner',
    administrator: 'Administrator'
};

export const TABLE_CONST = {
    DEFAULT_PER_PAGE: 10
};

export const quizCategoryColors = {
    learning: '#efd66f',
    reading: '#ed6dad',
    writing: '#4ea9cb',
    oralcommunication: '#a469d1',
    numeracy: '#19a65b'
};

export const quizIds = ['acsf3', 'acsf4', 'vfh', 'acsf3shortcourse'];

// for date locale for date format purpose
export const DATE_FORMAT_LOCALE = 'en-AU';

export const EMAIL_TEMPLATES = {
    loginOtpLLNV2: {
        templateKey: 'userLoginOtpLLN',
        label: 'Login OTP',
        body: '<p>Hello <variable>userFirstName</variable>,</p><p>Your One Time password is: <strong><variable>userLoginOtp</variable></strong>.</p><p>This code is valid for 30 minutes.</p><p></p><p>If you have any questions about your account please contact your system administrator at <variable>adminCorrespondenceEmail</variable>.</p><p>Thanks,<br/>The RPL Robot System team.</p><p>Note: Please do not respond to this email.</p>',
        subject: 'RPL Robot One Time Passcode',
        group: 'rto'
    },
    userPasswordResetRequestV2: {
        templateKey: 'userPasswordResetRequest',
        label: 'Password Reset Request',
        body: "<p>Hello <variable>userFirstName</variable>,</p><p>We have received a request to reset your <variable>adminCorrespondenceName</variable> RPL Robot System password.</p><p>To reset your password, please click the button below (link expires in 24 hours):</p> <p><variable>userPasswordResetLinkClickable</variable></p><p>If the button above does not work, <b>copy and paste</b> this link into your browser:</p> <p><variable>userPasswordResetLink</variable></p> <hr/><p>If you don't want to change your password or you didn't request this reset, you can ignore this email.</p><p>If you have any questions about your account please contact your system administrator at <variable>adminCorrespondenceEmail</variable>.</p><p>Thanks,<br/>The RPL Robot System team.</p><p>Note: Please do not respond to this email.</p>",
        subject: 'Password Reset Request for your RPL Robot System Account',
        group: 'rto'
    },
    changePasswordLLNV2: {
        templateKey: 'userChangePassword',
        label: 'Success Change Password',
        body: '<p>Hello <variable>userFirstName</variable>,</p><p>Your have successfully change your password.</p><p></p><p>If you have any questions about your account please contact your system administrator at <variable>adminCorrespondenceEmail</variable>.</p><p>Thanks,<br/>The RPL Robot System team.</p><p>Note: Please do not respond to this email.</p>',
        subject: 'Success Change Password RPL Robot',
        group: 'rto'
    }
};

export const EMAIL_TEMPLATE_VARIABLES = [
    {
        id: 'learnerFirstName',
        label: 'Learner First Name',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['ACSF', 'VSL', 'REMINDER', 'completionEmail'],
        groups: ['learner', 'rto']
    },
    {
        id: 'learnerLastName',
        label: 'Learner Last Name',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['ACSF', 'VSL', 'REMINDER', 'completionEmail'],
        groups: ['learner', 'rto']
    },
    {
        id: 'linkToQuiz',
        label: 'Quiz Link (Clickable)',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['All'],
        groups: 'learner'
    },
    {
        id: 'plainLinkToQuiz',
        label: 'Quiz Link (Plain Text)',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['All'],
        groups: ['learner']
    },
    {
        id: 'tradingName',
        label: 'Trading Name',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['All'],
        groups: ['learner']
    },
    {
        id: 'userFirstName',
        label: 'User First Name',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['All'],
        groups: ['rto']
    },
    {
        id: 'userLoginOtp',
        label: 'OTP',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['userLoginOtpLLN'],
        groups: ['rto']
    },
    {
        id: 'adminCorrespondenceEmail',
        label: 'Admin Correspondence Email',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['All'],
        groups: ['rto']
    },
    {
        id: 'adminCorrespondenceName',
        label: 'Admin Correspondence Name',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['All'],
        groups: ['rto']
    },
    {
        id: 'userPasswordResetLink',
        label: 'Password Reset Link',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['userPasswordResetRequest'],
        groups: ['rto']
    },
    {
        id: 'userPasswordResetLinkClickable',
        label: 'Reset Password (Clickable)',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['userPasswordResetRequest'],
        groups: ['rto']
    },
    {
        id: 'learnerlistNameLearnerId',
        label: 'Learner List (Name, Learner Id)',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['learnerDeleted'],
        groups: ['rto']
    },
    {
        id: 'userPasswordCreateLinkClickable',
        label: 'Create Password (Clickable)',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['userInvite'],
        groups: ['rto']
    },
    {
        id: 'accessingLLNRobotDocLink',
        label: 'Accessing RPL Robot Link',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['userInvite'],
        groups: ['rto']
    },
    {
        id: 'llnRobotOverviewLink',
        label: 'RPL Robot Overview Link',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['userInvite'],
        groups: ['rto']
    },
    {
        id: 'inviterOrAdminCorrespondenceEmail',
        label: 'Inviter Name Or Admin Correspondence Name',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['dailySummary'],
        groups: ['rto']
    },
    {
        id: 'learnerlistLearnerIdNameEmail',
        label: 'Learner List (Learner ID, Name, Email)',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['dailySummary'],
        groups: ['rto']
    },
    {
        id: 'llnRobotLoginUrl',
        label: 'RPL Robot Login Url',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['All'],
        groups: ['rto']
    },
    {
        id: 'learnerQuizType',
        label: 'Learner Quiz Type',
        canAddTo: {
            subject: true,
            body: true
        },
        templates: ['completionEmail'],
        groups: ['rto']
    },
    {
        id: 'completionLogoImg',
        label: 'Completion Logo Image',
        canAddTo: {
            subject: false,
            body: true
        },
        templates: ['completionEmail'],
        groups: ['rto']
    }
];

/**
 * Store All static links/url
 */
export const STATIC_LINKS = {
    axcelarateSupport: 'https://support.lln.training/article/440-axcelerate-integration-setup',
    apiSupport: 'https://support.lln.training/category/441-student-management-system-sms-integrations',
    wisenetSupport: 'https://support.lln.training/article/558-wisenet-integration',
    webhookSupport: 'https://support.lln.training/webhooks',
    wisenetTestingCallbackUri: 'https://canary-api.lln.training/wn/callback'
};
export const DEFAULT_TABLE_BODY_ROW = {
    infos: [
        {
            list: [
                {
                    height: 25
                }
            ]
        }
    ]
};

export const DEFAULT_LOGO_URL = 'https://rpl-robot.s3.ap-southeast-2.amazonaws.com/assets/images/tlrg-logo-transparent.png';
export const RPL_ROBOT_LOGO_URL =
    process.env.REACT_APP_RPL_ROBOT_LOGO_URL ||
    'https://rpl-robot.s3.ap-southeast-2.amazonaws.com/assets/images/rpl-robot-logo-transparent-bg.png';

export const IMG_LOGO_SIZE = {
    xs: {
        width: 400,
        height: 200
    },
    sm: {
        width: 470,
        height: 230
    },
    md: {
        width: 650,
        height: 250
    },
    lg: {
        width: 680,
        height: 280
    },
    xl: {
        width: 700,
        height: 300
    }
};

export const SUMMARIZED_ASSESSMENT_STATUS = {
    pendingReview: { label: 'Pending Review', color: '#ed8115' },
    inProgress: { label: 'In Progress', color: '#3a94e7' },
    completed: { label: 'Completed', color: '#3fb34e' }
};

export const ASSESSMENT_DETAILED_STATUS = {
    notStarted: { label: 'Not Started', color: '#ffbc79' },

    evidenceSubmitted: {
        label: 'Evidence Submitted',
        color: '#89c6ff'
    },

    evidenceUnderReview: {
        label: 'Evidence Under Review',
        color: '#c0b4ff'
    },

    moreEvidenceRequired: {
        label: 'More Evidence Required',
        color: '#fca49b'
    },

    evidenceAccepted: {
        label: 'Evidence Accepted',
        color: '#95ffa3'
    },

    interviewRequired: {
        label: 'Interview Required',
        color: '#F39C12'
    },

    interviewScheduled: {
        label: 'Interview Scheduled',
        color: '#6df3e6'
    },

    interviewCompleted: {
        label: 'Interview Completed',
        color: '#009688'
    },

    mappingInProgress: {
        label: 'Mapping In Progress',
        color: '#b2b9e1'
    },

    pendingDecision: {
        label: 'Pending Decision',
        color: '#bd9ef4'
    },

    competent: {
        label: 'Competent',
        color: '#1ceb27'
    },

    notCompetent: {
        label: 'Not Competent',
        color: '#ff4a4a'
    }
};

export const ASSESSOR_ASSESSMENT_STATUS = [
    'Evidence Review',
    'Resubmitted Evidence Review',
    'Interview Scheduling',
    'Interview Mapping',
    'Final Determination'
];

export const QUALIFICATION_LEVEL_NAMES = {
    1: 'Certificate I',
    2: 'Certificate II',
    3: 'Certificate III',
    4: 'Certificate IV',
    5: 'Diploma',
    6: 'Advanced Diploma +'
};

export const REQUIREMENT_TYPES = ['PC', 'PE', 'KE'];

export const COURSE_STEP_JOURNEYS = {
    'course-info': {
        title: 'Course Information',
        subtitle: 'Course Basic Information & Units'
    },
    units: {
        title: 'Units',
        subtitle: 'Assign units to the course'
    },
    outcomes: {
        title: 'Outcomes',
        subtitle: 'Review & Validate AI Generated Outcomes'
    },
    'assessment-conditions': {
        title: 'Assessment Conditions',
        subtitle: 'Review & Validate Assessment Conditions'
    },
    'guest-guidance': {
        title: 'Guest Guidance',
        subtitle: 'Review & Validate AI Generated Guest Guidance'
    },
    'assessor-assignments': {
        title: 'Assigned Assessors',
        subtitle: 'Assign assessors to the course'
    },
    'review-and-publish': {
        title: 'Review & Publish',
        subtitle: 'Review Course Details & Publish'
    }
};

export const COURSE_STATUS = ['Active', 'Inactive', 'Draft'];

export const COURSE_SECTION_IDS = ['situation', 'objective', 'actions', 'challenges', 'result'];

export const LOGIN_USER_TYPES = {
    CANDIDATE: 'CANDIDATE',
    ASSESSOR: 'ASSESSOR',
    ADMIN: 'ADMINISTRATOR',
    GUEST: 'GUEST',
    ENROLMENT_OFFICER: 'ENROLMENT OFFICER',
    COMPLIANCE_MANAGER: 'COMPLIANCE MANAGER',
    AUDITOR: 'AUDITOR'
};

export const TIP_FOR_GOOD_EVIDENCE = [
    'Ensure the evidence is relevant to the outcome requirements',
    'Use documents, records, photos or other supporting material',
    "Include clear explanation of how the evidence relates to the candidate's work",
    'Check the files are clear and readable'
];

// Assessment Journey Stages
export const ASSESSMENT_STAGES = {
    INITIAL_SUBMISSION: 'Initial Submission',
    ASSESSOR_REVIEW: 'Assessor Review',
    FEEDBACK_PENDING: 'Feedback',
    RESUBMISSION_REVIEW: 'Resubmission Review',
    INTERVIEW_PENDING: 'Interview Pending',
    INTERVIEW_REVIEW: 'Interview Review',
    FINAL_DETERMINATION: 'Final Determination',
    APPEAL_REVIEW: 'Appeal Review'
};

export const ASSESSMENT_PHASES = {
    INITIAL_SUBMISSION: 'INITIAL_SUBMISSION',
    ASSESSOR_REVIEW: 'ASSESSOR_REVIEW',
    FEEDBACK_PENDING: 'FEEDBACK_PENDING',
    RESUBMISSION_REVIEW: 'RESUBMISSION_REVIEW',
    INTERVIEW_PENDING: 'INTERVIEW_PENDING',
    INTERVIEW_REVIEW: 'INTERVIEW_REVIEW',
    FINAL_DETERMINATION: 'FINAL_DETERMINATION',
    APPEAL_REVIEW: 'APPEAL_REVIEW'
};

// For Stage Journey Sub Status (Each Stage Status)
export const ASSESSMENT_STAGES_SUB_STATUS = {
    PENDING: 'Pending',
    PENDING_REVIEW: 'Pending Review',
    IN_PROGRESS: 'In Progress',
    IN_REVIEW: 'In Review',
    COMPLETED: 'Completed',
    REVIEWED: 'Reviewed'
};

// For Evidence Authenticity
export const EVIDENCE_AUTHENTICITIES = ['Authentic', 'Current'];

// For Evidence assessment Demonstrated
export const EVIDENCE_DEMONSTRATED_STATUS = {
    DEMONSTRATED: 'DEMONSTRATED',
    PARTIALLY_DEMONSTRATED: 'PARTIALLY DEMONSTRATED',
    NOT_DEMONSTRATED: 'NOT DEMONSTRATED'
};

// For Narattive Sections Question Flag for Follow Up
export const FOLLOW_UP_REASONS = [
    'Please provide more detail about your role and responsibilities',
    'Please provide more detail about the work you carried out',
    'Please provide more detail about how you made decisions during this work',
    'Please provide more detail about the workplace context',
    'Please explain the sequence of events more clearly',
    'Please clarify part of your response',
    'Other'
];

// Priority Options
export const PRIORITY_OPTIONS = [
    { value: 'HIGH', label: 'HIGH PRIORITY', color: '#d32f2f' },
    { value: 'MEDIUM', label: 'MEDIUM PRIORITY', color: '#ed6c02' },
    { value: 'LOW', label: 'LOW PRIORITY', color: '#0288d1' }
];

export const GUEST_EVIDENCE_REQUEST_STATUS = {
    NOT_STARTED: 'NOT STARTED',
    INVITED: 'INVITED',
    ACTIVATED: 'ACTIVATED',
    IN_PROGRESS: 'IN PROGRESS',
    SUBMITTED: 'SUBMITTED',
    COMPLETED: 'COMPLETED'
};

// Manage Email Template constants
export const PLACEHOLDER_URL = 'https://rpl-template.invalid/';

export const QUILL_FORMATS = ['header', 'bold', 'italic', 'underline', 'list', 'bullet', 'link'];

export const VARIABLE_LABELS = {
    userFirstName: 'First name',
    candidateFirstName: 'Candidate first name',
    candidateName: 'Candidate name',
    assessorFirstName: 'Assessor first name',
    assessorName: 'Assessor name',
    organisationName: 'Organisation name',
    adminCorrespondenceName: 'Organisation name',
    adminCorrespondenceEmail: 'Administrator email',
    userPasswordResetLinkClickable: 'Password reset button',
    userPasswordResetLink: 'Password reset URL',
    userLoginOtp: 'One-time passcode',
    candidateInviteLinkClickable: 'Invitation button',
    candidateInviteLink: 'Invitation URL',
    guestInviteLinkClickable: 'Guest invitation button',
    guestInviteLink: 'Guest invitation URL',
    assessmentUrl: 'Assessment link',
    assessmentOutcomeUrl: 'Assessment outcome link',
    assessmentCompletedBy: 'Assessment completed by',
    assessmentCompletedDate: 'Assessment completed date',
    feedbackUrl: 'Feedback link',
    guestEvidenceUrl: 'Guest evidence link',
    dueDate: 'Due date',
    closureDate: 'Closure date'
};

export const CANDIDATE_ASSESSMENT_INTERVIEW_QUESTION_STATUS = {
    REVIEWED: 'REVIEWED',
    PENDING_REVIEW: 'PENDING REVIEW'
};
export const ASSESSMENT_STAGE_LABELS = [
    {
        label: 'Evidence & Outcome Review',
        description: 'Review and assess all evidence against outcomes and requirements'
    },
    {
        label: 'Feedback',
        description: 'Provide feedback and guidance to candidate evidence resubmission'
    },
    {
        label: 'Resubmission Review',
        description: 'Review candidate resubmission and evidence'
    },
    {
        label: 'Interview',
        description: 'Generate interview and conduct interview with candidate'
    },
    {
        label: 'Interview Mapping',
        description: 'Map interview responses to requirements'
    },
    {
        label: 'Final Determination',
        description: 'Make final decision on competency'
    }
];

export const ASSESSMENT_ACTIVITY_TYPES = {
    // For Admin or Assessor Activity
    'candidate.invited': {
        activity: {
            title: 'created an RPL assessment',
            subTitle: 'Candidate was invited to complete an RPL assessment'
        }
    },
    'candidate.assessor_assigned': {
        activity: {
            title: 'assigned an Assessor',
            subTitle: 'Assigned assessor for the RPL assessment'
        }
    },
    'assessment.viewed': {
        activity: {
            title: 'Viewed assessment',
            subTitle: "Opened the candidate's RPL assessment for review"
        }
    },
    'evidence.evaluation.opened': {
        activity: {
            title: 'Opened outcome evidence'
        }
    },
    'evidence.evaluation.saved': {
        activity: {
            title: 'Reviewed Evidence'
        }
    },
    'outcome.opened': {
        activity: {
            title: 'Opened outcome'
        }
    },
    'outcome.evidence_gap_acknowledged': {
        activity: {
            title: 'Acknowledged an outcome evidence gap',
            subTitle: 'Confirmed that assessor review can proceed without attached evidence'
        }
    },
    'narrative.responses.viewed': {
        activity: {
            title: 'Viewed narrative response'
        }
    },
    'narrative.flagged.interview': {
        activity: {
            title: 'Flagged narrative response to interview'
        }
    },
    'requirement.viewed': {
        activity: {
            title: 'Viewed Requirement'
        }
    },
    'assessor.review.submitted': {
        activity: {
            title: 'Submitted evidence & outcome overview',
            subTitle: 'Completed and submitted the assessment review'
        }
    },
    'interview.question.created': {
        activity: {
            title: 'Created interview question'
        }
    },
    'interview.question.deleted': {
        activity: {
            title: 'Deleted interview question',
            subTitle: 'Removed an interview question from the assessment'
        }
    },
    'interview.questions.reordered': {
        activity: {
            title: 'Reordered interview questions',
            subTitle: 'Changed the order of interview questions in the assessment'
        }
    },
    'interview.question.updated': {
        activity: {
            title: 'Reviewed and updated interview questions'
        }
    },
    'add.assessment.notes': {
        activity: {
            title: 'Added a notes'
        }
    },
    'edit.assessment.notes': {
        activity: {
            title: 'Updated a notes'
        }
    },
    'requirement.final.determination.assessment': {
        activity: {
            title: 'Recorded final requirement determination'
        }
    },
    'complete.assessment': {
        activity: {
            title: 'Completed and submitted assessment'
        }
    },
    'assessment.appeal-details-approval': {
        activity: {
            title: 'Assessment appeal request approval'
        }
    },
    'candidate.due_date_updated': {
        activity: {
            title: 'Assessment due date updated'
        }
    },
    'complete.appeal.assessment': {
        activity: {
            title: 'Complete Appeal Assessment'
        }
    },
    'edit.assessment.closed-or-reopen': {
        activity: {
            title: 'Edit Assessment Closed or Reopen'
        }
    },
    'interview.mapping_review.updated': {
        activity: {
            title: 'Interview Mapping Review Updated'
        }
    },
    'interview.review.completed': {
        activity: {
            title: 'Interview Review Completed'
        }
    },
    'requirement.appeal.assessment': {
        activity: {
            title: 'Requirement Appeal Assessment'
        }
    },
    'resubmission.guidance.submitted': {
        activity: {
            title: 'Resubmission Guidance Submitted'
        }
    },

    // Candidate Activity
    'assessment.opened': {
        activity: {
            title: 'Candidate opened the assessment',
            subTitle: 'Accessed their RPL assessment'
        }
    },
    'assessment.response_created': {
        activity: {
            title: 'Candidate submitted a narrative response',
            subTitle: 'Answered a narrative assessment question'
        }
    },
    'assessment.response_updated': {
        activity: {
            title: 'Candidate updated a narrative response'
        }
    },
    'assessment.workplace_record_created': {
        activity: {
            title: 'Candidate created workplace record'
        }
    },
    'assessment.workplace_record_updated': {
        activity: {
            title: 'Candidate updated workplace record'
        }
    },
    'assessment.workplace_record_deleted': {
        activity: {
            title: 'Candidate deleted workplace record'
        }
    },
    'assessment.workplace_records_saved': {
        activity: {
            title: 'Candidate saved workplace records'
        }
    },
    'assessment.narrative_activity_frequency_updated': {
        activity: {
            title: 'Candidate updated narrative activity frequency'
        }
    },
    'assessment.evidence_uploaded': {
        activity: {
            title: 'Candidate upload evidence'
        }
    },
    'assessment.evidence_rationale': {
        activity: {
            title: 'Candidate add rationale to evidence'
        }
    },
    'assessment.evidence_linked': {
        activity: {
            title: 'Candidate link to evidence'
        }
    },
    'assessment.submitted': {
        activity: {
            title: 'Candidate submitted the assessment',
            subTitle: 'Completed and submitted their RPL assessment for review'
        }
    },
    'resubmission.evidence_uploaded': {
        activity: {
            title: 'Resubmission evidence uploaded'
        }
    },
    'resubmission.submitted': {
        activity: {
            title: 'Resubmission submitted'
        }
    }
};

export const ENTITLEMENT_TYPES = {
    USER: 'user',
    RPL: 'rpl',
    STORAGE: 'storage'
};

export const RPL_PLANS_URL = 'https://tlrg.com.au/pages/rpl-robot';
